import { DateTime } from 'luxon';
import { FormModel, FormProp } from '@pebula/nform';

declare module '@pebula/nform/lib/types/form-element-type' {
  interface FormElementType {
    dateRange: {
      min?: Date;
      max?: Date;
      filter?: (date: Date) => boolean;
      startAt?: Date;
    };
  }
}

@FormModel()
export class DateRange {
  constructor(private fromDate?: DateTime, private toDate?: DateTime) {}

  @FormProp({ vType: 'date' })
  start: DateTime = this.fromDate;

  @FormProp({ vType: 'date' })
  end: DateTime = this.toDate;

  /**
   * Return's the range as string (via toString()) in a { from, to } object.
   * The range is not time aware, time information is ignored and the range start from the start of the day of `from` to the end of the day of `to`
   */
  static fullRangeToString(dateRange: DateRange | null): { from: string; to: string } | undefined {
    if (dateRange && dateRange.end && dateRange.end >= dateRange.start) {
      return {
        from: dateRange.start.startOf('day').toString(),
        to: dateRange.end.endOf('day').toString(),
      };
    }
  }
}
